<div class="text-center" *ngIf="app?.isPlatformBrowserVar">
    <h1 class="text-center">404 Error</h1> 
    <h1 class="text-center">Page Not Found</h1> 
</div>


<div *ngIf="app?.isPlatformServerVar">

</div>